
    import {Component, Prop} from 'vue-property-decorator';
    import AbpBase from '@/lib/abpbase';
    import PageRequest from '@/store/entities/page-request';
    import {LinkedUserDto} from '@/Areas/AppAreaName/Views/admin/entities/LinkedUserDto'
    import {SwitchToLinkedAccountInput} from '@/Areas/AppAreaName/Views/admin/entities/SwitchToLinkedAccountInput'
    import createUserLinked from '@/Areas/AppAreaName/Views/admin/profile/userLinked/createUserLinked.vue'
    import AppAuthService from '@/lib/service/AppAuthService'
    import {UnlinkUserInput} from '@/Areas/AppAreaName/Views/admin/entities/UnlinkUserInput'

    import config from '@/lib/appconst'

    class linkedUser implements LinkedUserDto {
    tenantId ? : number;
    tenancyName ? : string;
    username ? : string;
    id ? : number;
}
@Component({
    components: {
        createUserLinked
    }

})
export default class userLinkedModal extends AbpBase {
    //父子组件创建属性
    @Prop({
        type: Boolean,
        default: false
    }) value: boolean

    //数据
    input: PageRequest = new PageRequest();
    userlist = new Array < linkedUser > ();
    showCreateUserLinkedModal: boolean = false;
    recentlyLinkedUsers = new Array < linkedUser > ();
    showDeleteUserLinkeModal = false;
    unlinkUserInput = new class unlinked implements UnlinkUserInput {
        tenantId ? : number;
        userId ? : number;
    }
    columns = [{
            title: this.L('Actions'),
            slot: 'login'
        },
        {
            title: this.L('UserName'),
            key: 'username'
        },
        {
            title: this.L('Delete'),
            slot: 'delete'
        }
    ]
    //计算属性
    get userLinkedlist() {
        return this.$store.state.userlinked.list;
    }
    getPage() {
        this.input.maxResultCount = this.$store.state.userlinked.pageSize;
        this.input.SkipCount = (this.$store.state.auditLogs.currentPage - 1) * this.$store.state.auditLogs.pageSize;
        this.$store.dispatch({
            type: 'userlinked/getAll',
            data: this.input
        }).then((reslut) => {

        })
    }
    //自定义方法
    addLinkNewAccount() {
        this.showCreateUserLinkedModal = true;
    }
    async switchToUser(row) {
        console.log(row)
        let input: SwitchToLinkedAccountInput = new class SwitchToLinkedAccountInput {
            targetTenantId ? : number;
            targetUserId ? : number;
        }
        input.targetTenantId = row.id;
        input.targetTenantId = row.tenantId;

        AppAuthService.logout(false);
        let rs = await this.$store.dispatch({
            type: 'account/switchToLinkedAccount',
            data: input
        })
        let targetUrl =
            config.appBaseUrl + '/#/' +
            config.signInAsSomeoneUrlSegment +
            '?switchAccountToken=' +
            rs.switchAccountToken;
        if (input.targetTenantId) {
            targetUrl = targetUrl + '&tenantId=' + row.tenantId;
        }
        location.href = targetUrl;

    }
    deleteLinkedUser(row) {
        this.unlinkUserInput.userId = row.id;
        this.unlinkUserInput.tenantId = row.tenantId;
        this.showDeleteUserLinkeModal = true;
    }
    save() {

    }
   async sure() {
      await this.$store.dispatch({
            type:'userlinked/unlinkUser',
            data:this.unlinkUserInput
        }).then(()=>{
            this.$Message.success('取消关联成功');
            this.getPage();
        })
        this.showDeleteUserLinkeModal = false
    }
    deleteVisibleChange() {
        this.showDeleteUserLinkeModal = false
    }
    visibleChange(value: boolean) {
        this.getPage();
        if (!value) {
            this.$emit('input', value)
        }

    }
}
